export var PackageTariffTypes;
(function (PackageTariffTypes) {
    PackageTariffTypes["Individual"] = "individual";
    PackageTariffTypes["Aggregated"] = "aggregated";
    PackageTariffTypes["Pooled"] = "pooled";
    PackageTariffTypes["IndividualPlus"] = "individualPlus";
})(PackageTariffTypes || (PackageTariffTypes = {}));
export var Platform;
(function (Platform) {
    Platform["Vodafone"] = "vodafone";
    Platform["EE"] = "ee";
    Platform["O2"] = "o2";
    Platform["Three"] = "three";
    Platform["O2Plan"] = "o2Plan";
    Platform["EEPlan"] = "EEPlan";
})(Platform || (Platform = {}));
export var DeviceCostLevels;
(function (DeviceCostLevels) {
    DeviceCostLevels[DeviceCostLevels["Low"] = 120] = "Low";
    DeviceCostLevels[DeviceCostLevels["Mid"] = 300] = "Mid";
    DeviceCostLevels[DeviceCostLevels["High"] = 600] = "High";
})(DeviceCostLevels || (DeviceCostLevels = {}));
export var FundingOptions;
(function (FundingOptions) {
    FundingOptions["Leasing"] = "leasing";
    FundingOptions["HardwareFund"] = "hardwareFund";
    FundingOptions["None"] = "none";
})(FundingOptions || (FundingOptions = {}));
